var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.388 8.269c-1.114-2.787-3.761-2.927-6.965-2.37L15.308 2l-2.368.697 1.115 3.76c-.557.14-1.254.419-1.95.558l-1.115-3.9-2.368.696 1.114 3.901c-.557.14-.975.28-1.532.42L5 9.243l.697 2.507c0 .001 1.81-.556 1.671-.556.975-.279 1.393.14 1.672.696l1.253 4.458h.28l-.28.14 1.811 6.268c0 .279 0 .836-.696 1.115l-1.672.558.279 2.925 3.065-.836 1.671-.417 1.116 3.9 2.368-.697-1.115-3.9c.696-.14 1.253-.279 1.95-.557l1.114 3.9 2.368-.696-1.114-3.9c3.9-1.394 6.408-3.205 5.711-7.105-.558-3.065-2.369-4.04-4.876-3.9 1.393-1.394 1.95-2.787 1.114-4.876zm-.836 9.471c.836 2.927-4.318 4.041-5.99 4.598l-1.532-5.293c1.672-.418 6.547-2.368 7.522.696zm-3.343-7.103c.835 2.647-3.484 3.622-4.877 4.04L12.94 9.94c1.393-.418 5.572-2.09 6.27.697z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBch);
export default __webpack_public_path__ + "static/media/BCH.8fb5547dd94fed19533af567a7f0108f.svg";
export { ForwardRef as ReactComponent };